/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as LogoLight } from '../../assets/logo-light.svg';
import CustomButton from '../../common/CustomButton/CustomButton';
import { Icon } from '../../common/Icon/Icon';
import Image from '../../common/Image/Image';
import { useDataContext } from '../../core/context/data.context';
import { useScreenSizeContext } from '../../core/context/screenSize.context';
import { useThemeContext } from '../../core/context/theme.context';
import { useUserContext } from '../../core/context/user.context';
import useModal from '../../core/hooks/useModal';
import UserDropdown from '../User/UserDropdown/UserDropdown';
import './Header.css';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    data: {
      generalData: { navigation, logo },
    },
    page,
  } = useDataContext();
  const isHomePage = page === 'world-home-page';
  const { isScrolled, setIsScrolled } = useThemeContext();
  const [wasScrolled, setWasScrolled] = useState(false);
  const { user } = useUserContext();
  const { isMobile } = useScreenSizeContext();
  // const burgerRef = useRef(null);
  const { modal, isOpen, close } = useModal();
  // const isUserPage =
  //   location.pathname.includes('/user') || location.pathname.includes('/subscription');
  // const isUserSubPage =
  //   (isUserPage && location.pathname.includes('/profile')) ||
  //   location.pathname.includes('/subscriptions') ||
  //   location.pathname.includes('/subscription');
  // const fromPG = document.referrer.includes('/pg');

  // const openNav = useCallback(() => {
  //   if (!burgerRef.current) return;
  //   open(burgerRef.current);
  // }, [open]);

  const navList = useMemo(
    () =>
      !navigation?.navItems?.length ? null : (
        <ul className="header__nav-list">
          {navigation.navItems.map((link: any) => (
            <li className="header__nav-item" key={link.label}>
              <NavLink
                className={({ isActive }) => `header__nav-link link${isActive ? ' active' : ''}`}
                to={link.href}
                replace={isOpen}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      ),
    [navigation?.navItems, isOpen],
  );

  useEffect(() => {
    if (document.body.style.inset) {
      document.body.style.inset = '0';
      setIsScrolled(false);
    }
    close();
  }, [isMobile, close, location.pathname, setIsScrolled]);

  useEffect(() => {
    if (!isScrolled || wasScrolled) return;
    setWasScrolled(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScrolled]);

  return (
    <header
      className={`header${isScrolled ? ' scrolled blur' : ''}${isHomePage && !user._id ? ' hidden' : ''}`}
    >
      <div className="wrap wrap--xl">
        <nav className="header__nav">
          {/* <Link className="header__logo" to="/">
            <span className="sr-only">Home page</span>
            {logo?.img ? (
              <Image className="header__logo-img" img={logo.img} size="small" />
            ) : isScrolled ? (
              <LogoDark className="header__logo-img" />
            ) : (
              <LogoLight className="header__logo-img" />
            )}
          </Link> */}
          {isHomePage ? null : (
            <Link className="header__back" to="/">
              <Icon.Arrow className="flip-x" />
              <span className="sr-only">Back to home page</span>
            </Link>
          )}
          {!user.token ? null : <UserDropdown />}
          {/* {isUserPage ? (
            <>
              {fromPG ? (
                <button
                  className="header__back link"
                  type="button"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Icon.Arrow className="icon flip-x" />
                  Back
                </button>
              ) : (
                <Link className="header__back link" to={isUserSubPage ? '/user' : '/'}>
                  <Icon.Arrow className="icon flip-x" />
                  {isUserSubPage ? 'Profile' : 'Back'}
                </Link>
              )}
              <UserDropdown />
            </>
          ) : (
            <>
              {!navigation?.navItems?.length ? null : isMobile ? (
                <CustomButton
                  className="header__burger link"
                  type="button"
                  onClick={openNav}
                  ref={burgerRef}
                  id="header-menu"
                >
                  Menu
                </CustomButton>
              ) : (
                navList
              )}
            </>
          )} */}
        </nav>
      </div>
      {modal({
        children: (
          <div className="header__mobile-nav">
            <CustomButton
              className="header__close"
              type="button"
              onClick={() => {
                navigate(-1);
              }}
              id="header-menu-close"
            >
              <span className="sr-only">Close menu</span>
              <Icon.Plus className="icon rotate-45" />
            </CustomButton>
            <Link className="header__logo header__logo--mobile" to="/" replace>
              <span className="sr-only">Home page</span>
              {logo?.img ? (
                <Image className="header__logo-symbol" img={logo.img} />
              ) : (
                <LogoLight className="header__logo-symbol" />
              )}
            </Link>
            {navList}
          </div>
        ),
        side: 'right',
        preventNavigate: true,
      })}
    </header>
  );
}

export default Header;
